var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['row', _vm.border ? 'row-border' : '']},[_c('p',{staticClass:"row-label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"row-value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }